module.exports = __webpack_public_path__ + "static/media/asc-phone.b148a17a.svg";